// Boardroom inventory — every booking flows through the on-site enquiry form.
export const BOARDROOMS = {
  toowoomba: [
    {
      key: "saba",
      name: "The Saba Boardroom",
      capacity: "Seats up to 10",
      attendeesMax: 10,
      hourlyRate: 30,
      location: "Toowoomba · Saba Workspace",
      blurb:
        "Our flagship Toowoomba boardroom — glass table, brick walls and a Smart Board ready for serious conversations.",
      imageUrls: [
        "https://customer-assets.emergentagent.com/job_cozy-workspaces/artifacts/wlr5cfa5_image.png",
        "https://customer-assets.emergentagent.com/job_cozy-workspaces/artifacts/h69wn1an_image.png",
        "https://customer-assets.emergentagent.com/job_cozy-workspaces/artifacts/j63m54yq_image.png",
      ],
    },
    {
      key: "glass",
      name: "The Glass Room",
      capacity: "Seats up to 5",
      attendeesMax: 5,
      hourlyRate: 25,
      location: "Toowoomba · Saba Workspace",
      blurb:
        "An intimate glass-walled meeting room for smaller sessions — close-knit conversations, exposed brick warmth.",
      imageUrls: [
        "https://customer-assets.emergentagent.com/job_cozy-workspaces/artifacts/m9i63yqk_image.png",
        "https://customer-assets.emergentagent.com/job_cozy-workspaces/artifacts/9iofmpm6_image.png",
        "https://customer-assets.emergentagent.com/job_cozy-workspaces/artifacts/25u4f9sr_image.png",
      ],
    },
  ],
  buderim: [
    {
      key: "buderim",
      name: "The Buderim Boardroom",
      capacity: "Seats up to 6",
      attendeesMax: 6,
      hourlyRate: 25,
      location: "Buderim · Sunshine Coast",
      blurb:
        "Our Sunshine Coast boardroom on Burnett Street — wide chevron-oak table, sheer drapes, and a large display screen ready for your meeting. Underground parking on Level 1 if you need it. Reserve by the hour, half-day or full day.",
      imageUrls: [
        "/img/buderim/buderim_1.jpg",
        "/img/buderim/buderim_2.jpg",
        "/img/buderim/buderim_3.jpg",
        "/img/buderim/buderim_4.jpg",
      ],
    },
  ],
};

export const DURATIONS = [
  { id: "1hr", label: "1 Hour", hours: 1 },
  { id: "2hr", label: "2 Hours", hours: 2 },
  { id: "4hr", label: "Half Day · 4 Hours", hours: 4 },
  { id: "8hr", label: "Full Day · 8 Hours", hours: 8 },
];
